/**
* Menu Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Menu Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'menu-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const $primary = $( '#menu-content-image-primary' );
      const $buffer = $( '#menu-content-image-buffer' );
      const $sections = $( '.menu-content__section' );

      let currentIndex = 0;
      let isAnimating = false;

      function crossfadeImage( src, alt ) {
        if ( isAnimating ) return;
        isAnimating = true;

        // Preload into buffer
        $buffer.attr( 'src', src );

        // Once buffer is loaded, crossfade
        $buffer.one( 'load', function() {
          gsap.set( $buffer, {opacity: 0} );
          gsap.to( $buffer, {
            opacity: 1,
            duration: 0.25,
            onComplete: function() {
              console.log( src );
              // Swap buffer into primary
              $primary.attr( 'src', src );
              $primary.attr( 'alt', alt || '' );

              // Reset buffer
              gsap.set( $primary, {opacity: 1} );
              gsap.set( $buffer, {opacity: 0} );
              $buffer.attr( 'src', '' );

              isAnimating = false;
            },
          } );
        } );
      }

      function activateSection( index ) {
        if ( index === currentIndex ) return;

        $sections.eq( currentIndex ).removeClass( 'is-active' );
        $sections.eq( index ).addClass( 'is-active' );

        const src = $sections.eq( index ).data( 'image-src' );
        const alt = $sections.eq( index ).data( 'image-alt' );

        if ( src ) {
          crossfadeImage( src, alt );
        }

        currentIndex = index;
      }

      let topOffset = $( '.navbar' ).height();

      if ( $( '#wpadminbar' ).length ) {
        topOffset += $( '#wpadminbar' ).height();
      }
      $sections.each( function( index ) {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top ' + ( topOffset + 40 ),
          end: 'bottom ' + ( topOffset + 40 ),
          onEnter: function() {
            activateSection( index );
          },
          onEnterBack: function() {
            activateSection( index );
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'menu-content', COMPONENT );
} )( app );
